import React, { useState } from "react";
import { skillGroups } from "../data/portfolio";

const SkillsWindow = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = skillGroups[activeIndex];

  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="px-3 pt-3">
        <p className="text-sm font-bold">Technical areas I am building on.</p>
      </div>

      <div className="mt-3 flex gap-[2px] px-3" role="tablist" aria-label="Skill categories">
        {skillGroups.map((group, index) => (
          <button
            key={group.title}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            onClick={() => setActiveIndex(index)}
            className={`win-focus-dotted -mb-[2px] px-3 py-1.5 text-xs font-bold ${
              index === activeIndex ? "win-raised relative z-10" : "win-sunken text-[#404040]"
            }`}
          >
            {group.title}
          </button>
        ))}
      </div>

      <div className="win-raised relative z-0 mx-3 mb-3 flex-1 overflow-auto p-4">
        <h3 className="text-lg font-black">{active.title}</h3>
        <p className="mt-2 max-w-xl text-sm leading-6 text-[#303030]">{active.description}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {active.skills.map((skill) => (
            <span key={skill} className="win-sunken-thin flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-bold">
              <span aria-hidden="true">✓</span>
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillsWindow;
